import ObjectFitClass from '../utils/_object-fit'
import $ from 'jquery'
import selectize from 'selectize'
import LazyLoad from '../modules/_lazy-load'
import { Scroll } from '../utils/_smooth-scroll'

selectize.define('plugin_name', function (options) {
  this.require('remove_button')
})

export default function EmployeesFilter () {
  const containers = document.querySelectorAll('.mtt-employees')

  if (containers.length) {
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i]

      const selectize = new addSelectizes()
      selectize.init()
      const filters = new addEmployeesFilter(container)
      filters.init()
    }
  }
}

class addEmployeesFilter {
  constructor (container) {
    this.container = $(container)
    this.filters = this.container.find('.mtt-filter')
    this.EMPLOYEES_SEARCH = this.container.find('#employee-search')
    this.EMPLOYEES_BUSINESS_AREA = this.container.find('#business-area-select')
    this.EMPLOYEES_LOCATION = this.container.find('#location-select')
    this.EMPLOYEES_DEST = this.container.find('.grid-container')
    this.LOCATION_SELECT = document.getElementById('location-select')
    this.selectizeElement = this.LOCATION_SELECT ? this.LOCATION_SELECT.selectize : null

    this.loader = $('#loader')
    this.s = ''
    this.businessArea = ''
    this.location = ''

    this.init = () => {
      this.addSearch()
      this.addFilters()
    }
  }

  addSearch () {
    let timeout = null
    this.EMPLOYEES_SEARCH.on('input', (e) => {
      e.preventDefault()

      if (timeout) {
        clearTimeout(timeout)
      }

      timeout = setTimeout(() => {
        this.s = this.EMPLOYEES_SEARCH.val()
        this.getEmployees()
      }, 500)
    })
  }

  addFilters () {
    this.EMPLOYEES_BUSINESS_AREA.on('change', () => {
      this.businessArea = this.EMPLOYEES_BUSINESS_AREA.val()

      this.getEmployees()
    })

    this.EMPLOYEES_LOCATION.on('change', () => {
      this.location = this.EMPLOYEES_LOCATION.val()

      this.getEmployees()
    })

    const that = this
    $(document).on('click', '.info-box__field--link .inline-button', function () {
      if (that.selectizeElement) {
        that.selectizeElement.addItem(this.getAttribute('data-id'), false)
      }
      that.location = $(this).attr('data-id')
      that.getEmployees()
      Scroll(that.container, false)
    })
  }

  // Ajax request function
  getEmployees () {
    // Show loader
    this.loader.addClass('show')

    // Set ajax data
    const data = {
      action: 'filter_employees',
      businessArea: this.businessArea,
      location: this.location,
      s: this.s
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, (response) => {
      if (response !== 0) {
        // Post response
        if (response.employees !== '') {
          this.EMPLOYEES_DEST.html(response.employees)
        } else if (response.showMessage) {
          this.EMPLOYEES_DEST.html('<div class="no-posts">No employees matched your criteria </div>')
        } else {
          this.EMPLOYEES_DEST.html('')
        }

        if ($(window).width() <= 580) {
          $('html, body').animate({
            scrollTop: this.EMPLOYEES_DEST.offset().top - 64
          }, 1000)
        }

        // Hide loader
        this.loader.removeClass('show')

        new LazyLoad()
        new ObjectFitClass()
      }
    })
  }
}

class addSelectizes {
  constructor () {
    this.init = () => {
      this.addSelects()
    }
  }

  addSelects () {
    $('.selectize').selectize({
      plugins: ['remove_button'],
      persist: true,
      create: false,
      copyClassesToDropdown: false,
      closeAfterSelect: true
    })
  }
}
